import { Card, DataDisplay, Grid, Stack, Typography, formatPhoneNumber } from "@compass/core";
import { TextingQueueDetailDto } from "generated/openApi";
import { useDateTime } from "hooks";
import { TextingStatusChip } from "../TextingStatusChip";

export const TextingQueueInfo = (props: { textingQueue: TextingQueueDetailDto }) => {
  const formatDateTime = useDateTime();
  const queue = props.textingQueue;

  return (
    <Stack spacing="lg">
      <Card header="Queue Information">
        <Grid container spacing="lg">
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Status">
              {queue.status ? <TextingStatusChip status={queue.status} /> : "-"}
            </DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Person Type">{queue.personType || "-"}</DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Sent/Total">{queue.sent}/{queue.total}</DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Source Number">{formatPhoneNumber(queue.sourcePhoneNumber) || "-"}</DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Scheduled Date">{formatDateTime(queue.scheduledDate) || "-"}</DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Completed Date">{formatDateTime(queue.completedDate) || "-"}</DataDisplay>
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <DataDisplay label="Cancelled Date">{formatDateTime(queue.cancelledDate) || "-"}</DataDisplay>
          </Grid>
        </Grid>
      </Card>

      <Card header="Message">
        <Typography sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
          {queue.message || "-"}
        </Typography>
      </Card>
    </Stack>
  );
};
